import { Translation } from '@ps/web-shared-components';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import CTAButton from '../../../../../CTAButton/CTAButton';
import { isDenmarkCitizen } from '../../../../utils/rmf';
import Base from '../../../RMFVerification/components/Celebration/components/Base/Base';
import RMFCompletedAlert from '../RMFCompletedAlert/RMFCompletedAlert';
import RMFCompletedButtonsGroup from '../RMFCompletedButtonsGroup/RMFCompletedButtonsGroup';
import RMFCompletedContainer from '../RMFCompletedContainer/RMFCompletedContainer';

import {
  TXTWCL_Complete_your_profile_or_make__ELL,
  TXTWCL_Deposit,
  TXTWCL_Final_Steps,
  TXTWCL_YouXre_all_set,
  TXTWCL_YouXre_ready_to_ante_up_and_jo_ELL,
  TXTWCL_Your_account_has_been_createdX_1,
  TXTWCL_Your_profile_is_all_set
} from './RMFCompletedDK.messages.json';

const pageSubtitle = (
  <>
    <Translation {...TXTWCL_Your_account_has_been_createdX_1} />{' '}
    <Translation {...TXTWCL_Complete_your_profile_or_make__ELL} />
  </>
);
const translations = (denmarkCitizen: boolean) => {
  if (denmarkCitizen) {
    return {
      title: TXTWCL_Final_Steps,
      pageTopTitle: TXTWCL_Your_profile_is_all_set,
      pageTopSubtitle: <Translation {...TXTWCL_YouXre_ready_to_ante_up_and_jo_ELL} />
    };
  } else {
    return {
      title: TXTWCL_Final_Steps,
      pageTopTitle: TXTWCL_YouXre_all_set,
      pageTopSubtitle: pageSubtitle
    };
  }
};

const RMFCompletedDK: React.FC = () => {
  const citizenship = useSelector(select.account.getUserCitizenship);
  const denmarkCitizen = isDenmarkCitizen(citizenship || '');

  return (
    <RMFCompletedContainer
      page={RMFCompletedDK}
      title={TXTWCL_Final_Steps}
      pageTopTitle={translations(denmarkCitizen).pageTopTitle}
      pageTopSubtitle={translations(denmarkCitizen).pageTopSubtitle}
    >
      {denmarkCitizen ? (
        <CTAButton type="submit" translation={TXTWCL_Deposit} />
      ) : (
        <div>
          <RMFCompletedAlert>
            <Base />
          </RMFCompletedAlert>
          <RMFCompletedButtonsGroup />
        </div>
      )}
    </RMFCompletedContainer>
  );
};

RMFCompletedDK.displayName = 'RMFCompletedDK';
export default RMFCompletedDK;
